import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})

export class TitleChangeService {
  private puidPermissions: any = {};

  constructor(private title: Title, private router: Router, private activatedRoute: ActivatedRoute, private configService: ConfigService) {
    this.updateTitle();
  }

  updateTitle() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.paramMap.get('puid') || '';
      })
    ).subscribe(async (puid) => {
      if (puid) {
        try {
          // Use PUID-specific configuration instead of loading all permissions
          if (!this.puidPermissions[puid]) {
            // Check if configuration is already loaded for this PUID
            const config = this.configService._allConfigurationData;
            if (config?.visamonkPermissions?.[puid]) {
              this.puidPermissions[puid] = config.visamonkPermissions[puid];
            } else {
              // If not loaded, load PUID-specific configuration
              const puidConfig = await this.configService.getConfigurationByPuid(puid);
              if (puidConfig?.visamonkPermissions?.[puid]) {
                this.puidPermissions[puid] = puidConfig.visamonkPermissions[puid];
              }
            }
          }

          const tabName = this.puidPermissions[puid]?.tabName || 'VisaMonk';
          this.title.setTitle(tabName);
          this.updateFavicon("/assets/logo/favicon.png");
        } catch (error) {
          console.error('Error loading PUID permissions:', error);
          this.title.setTitle('VisaMonk');
        }
      } else {
        this.title.setTitle('VisaMonk');
      }
    });
  }

  private updateFavicon(iconPath: string) {
    let link: HTMLLinkElement = document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.rel = 'icon';
    link.href = iconPath;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
}
